export default "__VITE_ASSET__D2KXJd7v__"